import { paramsObjAsUrlParams } from "../network/RequestUtils";

/**
 * Update the URL and back-stack to reflect the new search.
 * <p>
 * Do not add new entries to the back-stack as this would likely confuse
 * our users.
 */
export function updateHistoryUrl(parameters: object, anchor?: string, historyData?: unknown) {
    if (!globalThis?.history) {
        return;
    }

    let newUrl = globalThis.location.protocol
        + "//"
        + globalThis.location.host
        + globalThis.location.pathname;
    const paramText = paramsObjAsUrlParams(parameters);
    if (paramText) {
        newUrl += "?" + paramText;
    }

    if (anchor) {
        if (!anchor.startsWith('#')) {
            newUrl += '#';
        }
        newUrl += anchor;
    }

    globalThis.history.replaceState(historyData || parameters, "", newUrl);
}
